import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Grid,
  Typography,
  ButtonBase,
  Skeleton,
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Img } from 'pages/vendor/profileVendor/ProfileVendorStyle';
import profilePic from 'assets/images/SubVendorLogo.svg';
import location from 'assets/images/smLocationIcon.svg'
import star from 'assets/images/smStar.svg';
import editmore from 'assets/images/moreEditIcon.svg';
import deleteicon from 'assets/images/delete.svg';
import deactive from 'assets/images/deActivate.svg';
import block from 'assets/images/block.svg';

function SubHeader(props) {
  const details = props?.details
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleOnError = (e) => {
    e.target.src = profilePic
  }

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  }
  const handleMenuClose = () => {
    setAnchorEl(null);
  }
  const handleMenuItemClick = (actionType) => {
    setSelectedItem(actionType);
    switch (actionType) {
      case 'Deactivate':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Block':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Activate':
        props?.onClickStatusIcon(actionType);
        break;
      case 'Unblock':
        props?.onClickStatusIcon(actionType);
        break;
      default:
        // Handle other menu item actions if needed
        break;
    }
    handleMenuClose();
  };
  const getConditionalMenuItems = () => {
    const status = details?.status || '';

    switch (status.toLowerCase()) {
      case 'active':
        if(props?.tabName  === 'customer'){
          return ['Block'];
        }else{
          return ['Deactivate', 'Block'];
        }
      case 'inactive':
        return ['Activate', 'Block'];
      case 'blocked':
        return ['Unblock'];
      default:
        return [];
    }
  };

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case 'blocked':
        return block;
      case 'block':
        return block;
      case 'edit':
        return editmore;
      case 'deactivate':
        return deactive;
      case 'delete':
        return deleteicon;
      case 'unblock':
        return block;
      case 'activate':
        return deactive;
      default:
        return editmore;
    }
  };


  return (
    <Grid
      container
      item
      md={props?.type === 'Vehicle' ? 12 : 8.3}
      direction="column"
      spacing={2}
      className="paddingInline"
    >
      {props?.loader ?  <Skeleton variant="rounded" height={200} /> :
      <div>
        <Grid item className="profileVendor">
          <Grid item container
            direction='row'
            justifyContent='space-between'>
            <Grid item>
              <ButtonBase className="vendorPic">
                <Img
                  alt="complex"
                  src={details?.avtar ? details?.avtar?.url : profilePic}
                  onError={handleOnError}
                  className='borderRounded height100 width100 backgroundWhite cursorDefault'
                />
              </ButtonBase>
            </Grid>
            <Grid item>
              <ButtonBase>
                <div>
                  {/* Add the "More" icon that opens the menu */}
                  {(props?.type !== 'Vehicle') && (details?.status?.toLowerCase() !== 'pending') && props?.tabName !== 'compliance' &&
                  <IconButton onClick={handleMenuOpen} className='colorWhite'>
                    <MoreVertIcon />
                  </IconButton>}

                  {/* Render the menu items */}
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    {getConditionalMenuItems().map((menuItem, index) => (
                      <MenuItem
                        key={index}
                        onClick={() => handleMenuItemClick(menuItem)}
                      >
                        <span className="marginRight10 alignItem">
                          <img src={moreIconSrc(menuItem)} alt={menuItem} />
                        </span>
                        <Typography className="font16 fontSemi">
                          {menuItem}
                        </Typography>
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              </ButtonBase>
            </Grid>
          </Grid>

          <Typography
            gutterBottom
            className="font20 fw600 marginLeft40 marginTop textCaptialize"
            variant="subtitle1"
            component="div"
          >
            {details?.companyName ? details?.companyName : details?.name ? details?.name : details?.complianceName ? details?.complianceName : details?.carModel ? details?.carModel : details?.firstName ? details?.firstName + " " + details?.lastName : 'Not Available'}
            {details?.rating && <span className='fw400 font14'><img src={star} alt="star" className='feedbackStar marginLeft16' />{" " + details?.rating}</span>}
          </Typography>
          <Grid item xs container direction="row">
            <Grid item xs>
              <Typography
                className="font14 fontNormal colorGrey marginLeft40"
                variant="body2"
                gutterBottom
              >
                <span>{props?.type !== 'Vehicle' && <img src={location} alt='location' className='marginRight10' />}</span>{details?.city ? details?.city : details?.location ? details?.location  : details?.regNumber ? details?.regNumber : 'Not Available'}
              </Typography>
            </Grid>
            <Grid item className='marginRight10'>
              {(details?.status || details?.isApproved) && (details?.status !== null || details?.isApproved !== null) && <Typography className={`profileButton ${details?.status ? details?.status + 'Btn' : details?.isApproved + 'Btn'}`}
              >
                {details?.status ? details?.status : details?.isApproved ? details?.isApproved : 'Not Available'}
              </Typography>}
            </Grid>
          </Grid>
        </Grid>
      </div>}
    </Grid>
  );
}

export default SubHeader;
